import { useNavigate } from "react-router-dom";
import React, { useContext, useState } from "react";
import { AuthContext } from "../AuthContext";
import Spinner from "react-bootstrap/Spinner";
import axios from "axios";
import { API_URL } from "../../constants";
import withAuth from "../../auth";
import {Breadcrumb} from "react-bootstrap";

const PromoCodeCreate = () => {
    const navigate = useNavigate();
    const { token, setToken } = useContext(AuthContext);
    const [error, setError] = useState('');
    const [isSubmitted, setIsSubmitted] = useState(false);
    const [formData, setFormData] = useState({
        code: '',
        discount_type: 'percentage',
        discount_value: '',
        valid_from: '',
        valid_to: '',
        usage_limit: 1,
        is_active: true
    });

    const handleChange = (e) => {
        const { name, value, type, checked } = e.target;
        setFormData({
            ...formData,
            [name]: type === 'checkbox' ? (checked ? 1 : 0) : value
        });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        setError('');
        setIsSubmitted(true);
        try {
            const response = await axios.post(`${API_URL}/api/admin/promo-codes/create`, formData, {
                headers: { 'Authorization': `Bearer ${token}` }
            });

            if (response.data.message) {
                alert(response.data.message);
                navigate('/promo-codes');
            }
        } catch (error) {
            if (error.response && error.response.status === 401) {
                localStorage.removeItem('authToken');
                setToken(null);
                navigate('/');
            }
            if (error?.response?.data?.errors) {
                const errors = error.response.data.errors;
                const errorMessages = Object.keys(errors).map(key => errors[key].join(' ')).join(' ');
                setError(errorMessages);
            } else if (error?.response?.data?.message) {
                setError(error.response.data.message);
            } else {
                setError('An error occurred. Please try again later.');
            }
        } finally {
            setIsSubmitted(false);
        }
    };

    return (
        <div className="container-fluid mt-3">
            <Breadcrumb>
                <Breadcrumb.Item href="/promo-codes">Promo Code List</Breadcrumb.Item>
                <Breadcrumb.Item active>Create</Breadcrumb.Item>
            </Breadcrumb>
            <h1 className="text-center">Create a new promo code</h1>
            {error && <div className="alert alert-danger">{error}</div>}
            <div className="row justify-content-center">
                <div className="col-md-4">
                    <div className="card">
                        <div className="card-body" align={'center'}>
                            <form onSubmit={handleSubmit} className="needs-validation" noValidate>
                                <div className="mb-3">
                                    <label htmlFor="code" className="form-label">Promo Code</label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        id="code"
                                        name="code"
                                        value={formData.code}
                                        onChange={handleChange}
                                        required
                                    />
                                </div>
                                <div className="mb-3">
                                    <label htmlFor="discount_type" className="form-label">Discount Type</label>
                                    <select
                                        className="form-control"
                                        id="discount_type"
                                        name="discount_type"
                                        value={formData.discount_type}
                                        onChange={handleChange}
                                        required
                                    >
                                        <option value="percentage">Percentage</option>
                                        <option value="fixed">Fixed</option>
                                    </select>
                                </div>
                                <div className="mb-3">
                                    <label htmlFor="discount_value" className="form-label">Discount Value</label>
                                    <input
                                        type="number"
                                        className="form-control"
                                        id="discount_value"
                                        name="discount_value"
                                        value={formData.discount_value}
                                        onChange={handleChange}
                                        required
                                    />
                                </div>
                                <div className="mb-3">
                                    <label htmlFor="valid_from" className="form-label">Valid From</label>
                                    <input
                                        type="datetime-local"
                                        className="form-control"
                                        id="valid_from"
                                        name="valid_from"
                                        value={formData.valid_from}
                                        onChange={handleChange}
                                        required
                                    />
                                </div>
                                <div className="mb-3">
                                    <label htmlFor="valid_to" className="form-label">Valid To</label>
                                    <input
                                        type="datetime-local"
                                        className="form-control"
                                        id="valid_to"
                                        name="valid_to"
                                        value={formData.valid_to}
                                        onChange={handleChange}
                                        required
                                    />
                                </div>
                                <div className="mb-3">
                                    <label htmlFor="usage_limit" className="form-label">Usage Limit</label>
                                    <input
                                        type="number"
                                        className="form-control"
                                        id="usage_limit"
                                        name="usage_limit"
                                        value={formData.usage_limit}
                                        onChange={handleChange}
                                        required
                                    />
                                </div>
                                <div className="mb-3 form-check">
                                    <input
                                        type="checkbox"
                                        className="form-check-input"
                                        id="is_active"
                                        name="is_active"
                                        checked={formData.is_active}
                                        onChange={handleChange}
                                    />
                                    <label htmlFor="is_active" className="form-check-label">Active</label>
                                </div>
                                <button type="submit" className="btn btn-primary">
                                    {isSubmitted
                                        ? <><Spinner as="span" animation="border" size="sm" role="status"
                                                     aria-hidden="true"/>&nbsp;Creating...</>
                                        : "Create"
                                    }
                                </button>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default withAuth(PromoCodeCreate);
